module.exports = __webpack_public_path__ + "static/media/home_gfx1.0cf31c32.png";